"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Form = {
  styles: function styles(theme) {
    return {
      column: {
        "& [type='submit']": {
          marginTop: theme.spacing.base
        }
      },
      row: {
        "& [type='submit']": {
          // this is to keep submit button vertically aligned with the inputs when they have inline errors displayed
          marginTop: theme.spacing.base * 3.5 + 1
        }
      }
    };
  }
};
var _default = exports.default = Form;